import * as React from 'react';
import { gql } from '@apollo/client';
import { useCallback } from 'react';
import { useDeleteImportFolderMutation } from '../../../../models/graphql';
import { DeleteFolderModalView } from './DeleteFolderModal.view';

gql`
  mutation DeleteImportFolder($importFolderId: ID!) {
    deleteImportFolder(importFolderId: $importFolderId)
  }
`;

export type DeleteFolderModalApolloProps = {
  // ...
};

export const DeleteFolderModalApollo = (props: DeleteFolderModalApolloProps): JSX.Element => {
  const [deleteImportFolder] = useDeleteImportFolderMutation();

  const deleteFolderHandler = useCallback(
    async (id: string) => {
      await deleteImportFolder({
        variables: { importFolderId: id },
        update: cache => {
          cache.evict({ id: cache.identify({ id: id, __typename: 'ImportFolder' }) });
          cache.gc();
        }
      });
    },
    [deleteImportFolder]
  );

  const viewProps = {
    ...props,
    deleteFolderHandler
  };

  return <DeleteFolderModalView {...viewProps} />;
};
